/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useContext } from "react";
import AppContext from "AppContext";
import { useSelector } from "react-redux";
import { getEnvVar } from "utils/env";

function NotificationsMonitor() {
    const { user } = useSelector((state) => state.Login);

    const {
        api: {
            General: { GeneralNotifications },
            Chat: { Notifications },
        },
        setNotifications,
    } = useContext(AppContext);

    const getNotifications = async () => {
        try {
            console.log("Fetching notifications...");
            const identityToNotify1 = String(user.email).replace("@", "|_at_|");
            const identityToNotify2 = getEnvVar("VITE_CHAT_IDENTITY");
            const responses = await Promise.all([
                Notifications.getAllUnreadByIdentityToNotify(identityToNotify1),
                Notifications.getAllUnreadByIdentityToNotify(identityToNotify2),
                GeneralNotifications.fildAllBySessionId(),
            ]);
            const notificationsObject = {
                [identityToNotify1]: responses[0] || [],
                [identityToNotify2]: responses[1] || [],
                general: responses[2] || [],
            };
            setNotifications(notificationsObject);
        } catch (error) {}
    };

    useEffect(() => {
        let interval;
        if (user) {
            getNotifications();
            interval = setInterval(() => {
                getNotifications();
            }, 15000);
        }

        return () => interval && clearInterval(interval);
    }, [user]);

    return null;
}

export default NotificationsMonitor;
